import { useQuery } from 'react-query';
import { getTravelArrangementsById } from 'RestAPIs/travel-arrangements';
import { TravelArrangementsData } from '../types';

type TravelArrangementsByIdParams = {
  employeeId?: number;
  empTrvArrangementId?: number;
};

function useGetTravelArrangementsById<T = TravelArrangementsData>(
  { employeeId, empTrvArrangementId }: TravelArrangementsByIdParams,
  options?: any
) {
  const { data, isFetching, isError, refetch, isLoading } = useQuery(
    ['travelArrangementsById', employeeId, empTrvArrangementId],
    async () => {
      if (!employeeId || !empTrvArrangementId) return null;
      const { data } = await getTravelArrangementsById(
        employeeId,
        empTrvArrangementId
      );
      return data as T;
    },
    {
      enabled: !!employeeId && !!empTrvArrangementId,
      ...options
    }
  );

  return { data, isFetching, isError, refetch, isLoading };
}

export default useGetTravelArrangementsById;
